import PhraseParentheses from "./PhraseParentheses";

const TokenElement = ({
  element,
  lineHeight,
  handleClickToken,
  isSelectable = true,
}) => {
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
      }}
    >
      {element.phraseStart.map((phrase) => (
        <PhraseParentheses phrase={phrase} isStart={true} />
      ))}
      <div
        style={{
          marginTop: "20px",
          marginBottom: `calc(${lineHeight} - 20px)`,
          cursor: isSelectable ? "pointer" : "default",
          textDecoration: isSelectable ? "underline" : "none",
          textDecorationColor: "#737373",
          textUnderlineOffset: "5px",
        }}
        onClick={isSelectable ? () => handleClickToken() : undefined}
      >
        {element.text}
      </div>
      {element.phraseEnd.map((phrase) => (
        <PhraseParentheses phrase={phrase} isStart={false} />
      ))}
      <div>{element.space_right > 0 && " "}</div>
    </div>
  );
};

export default TokenElement;
